import { usePage } from "@inertiajs/react";

import type { User } from "@/serializers";

import { Footer } from "./Footer";
import { Header } from "./Header";

interface LayoutProps {
  currentUser: User;
  children: React.ReactNode;
}

export default function Layout({ currentUser, children }: LayoutProps) {
  const { flash } = usePage().props;

  return (
    <div className="relative flex min-h-screen flex-col overflow-hidden bg-white font-sans font-light text-gray-800 transition-colors duration-300">
      <Header currentUser={currentUser} />

      <main className="flex-grow">
        <div className="container mx-auto px-4 py-8 sm:px-6 lg:px-8 print:w-full print:!px-2">
          {flash.alert && (
            <div
              className="border-ink relative mb-2 border-2 bg-red-100 px-4 py-3 text-red-800 shadow-sm"
              role="alert"
            >
              <span className="block sm:inline">{flash.alert}</span>
            </div>
          )}
          {flash.notice && (
            <div
              className="border-ink relative mb-2 border-2 bg-green-100 px-4 py-3 text-green-800 shadow-sm"
              role="alert"
            >
              <span className="block sm:inline">{flash.notice}</span>
            </div>
          )}
          {children}
        </div>
      </main>

      <Footer />
    </div>
  );
}
